import { SVGComponentProps } from "./utils/Types"

const ArrowLeftIcon = ({ width = 20, height = 20, className }: SVGComponentProps) => {
    return (
        <svg
            width={width}
            className={`text-current ${className}`}
            height={height}
            viewBox="0 0 27 27"
            fill="none">
            <path
                d="M21.375 13.5L5.625 13.5"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round" />
            <path
                d="M12.375 20.25L5.625 13.5L12.375 6.75"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round" />
        </svg>
    )
}

export default ArrowLeftIcon
